import styled from "styled-components"

export const SearchResultsContainer = styled.div`
  background: var(--cloudGrey);
  ul {
    list-style: none;
    margin-left: 0;
    color: var(--illiniDarkBlue);
  }

  .search-results {
    width: 100%;
  }
  .search-results li {
    margin-bottom: 1rem;
  }

  li img {
    margin-right: 0.5rem;
    height: 1rem;
    margin-bottom: 0;
  }
  li span {
    margin-right: 1rem;
  }

  .cardContainer {
    width: 100%;
    margin-bottom: 0.5rem;
  }

  .innerContainer {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: flex-start;
    width: 880px;
    margin: 0 auto;
    max-width: 100%;
    padding: 2rem;
    background: var(--cloudGrey);
  }
`
